import { AnnotationModel, CaptureModel, SampleModel, TalentModel } from 'core/models';
import moment from 'moment';
import { Exceptions } from 'utils/constants';
import { doThrowOnResponse, getToken, parseObjectTypes, parseValue } from 'utils/helper';
import { logger } from 'utils/logger';

export const getCapture = async (id, token) => {
    const url = `${process.env.REACT_APP_API_URL}/notes/${id}`;

    const formData = JSON.stringify({});

    logger.log(' GETTING SCAN DATA: ', formData);
    return fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Error getting capture');
        })
        .then((data) => {
            logger.log(data);
            const items = data.Items.map((val, idx) => {
                var item = createAnnotationModel(val);
                return item;
            });
            return items;
        })
        .catch((err) => {
            console.error('ERROR getting scan', err);
            throw err;
        });
};

export const updateCapture = async (capture, token) => {
    const url = `${process.env.REACT_APP_API_URL}/studioactions/${capture.actionPart}/${capture.actionSort}`;
    const tmpCapture = { ...capture };

    // remove the action part and sort
    delete tmpCapture.actionPart;
    delete tmpCapture.actionSort;

    const formData = JSON.stringify(tmpCapture);

    logger.log(' UPDATING Capture DATA: ', formData);
    return fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'PUT',
        body: formData,
    })
        .then((response) => {
            logger.log(response);
            if (response) {
                return response.json();
            }
            throw new Error('Error updating captures');
        })
        .then((data) => {
            if (data.__type && data.__type === Exceptions.SERIALISATION) {
                throw new Error('Error updating captures');
            }
            logger.log(data);
            return true;
            //return imgUploadUrl;
        })
        .catch((err) => {
            console.error(err);
            throw err;
        });
};

export const getCaptures = async (criteria, cursor, signal) => {
    const baseUrl = `${process.env.REACT_APP_API_URL}/studioactions/p`;
    const params = new URLSearchParams();

    logger.log(criteria, ' ============ CRITERIA');

    // Add parameters only if they have valid values
    if (criteria.sessionId && criteria.sessionId.length) {
        params.append('sessionId', criteria.sessionId);
    }
    
    if (criteria.client && criteria.client.length) {
        params.append('client', criteria.client);
    }
    
    if (criteria.star > -1) {
        params.append('star', criteria.star.toString());
    }
    
    if (criteria.sak > -1) {
        params.append('sak', criteria.sak.toString());
    }
    
    if (criteria.tags && criteria.tags.length && criteria.tags !== 'undefined') {
        params.append('tags', criteria.tags.toString());
    }
    
    if (criteria.colourTag && criteria.colourTag.length && criteria.colourTag !== 'undefined') {
        params.append('colourTag', criteria.colourTag.toString());
    }

    if (criteria.styleNumber && criteria.styleNumber.length) {
        params.append('styleNumber', criteria.styleNumber);
    }

    if (criteria.machineId && criteria.machineId.length && criteria.machineId !== 'undefined') {
        params.append('machineId', criteria.machineId);
    }

    if (criteria.catalogue && criteria.catalogue.value) {
        if (criteria.catalogue.value.since) {
            params.append('since', criteria.catalogue.value.since);
        }
        if (criteria.catalogue.value.until) {
            params.append('until', criteria.catalogue.value.until);
        }
    }

    if (cursor) {
        params.append('cursor', cursor);
    }

    // Always add limit
    params.append('limit', '100');

    const url = `${baseUrl}?${params.toString()}`;

    logger.log(' GETTING Captures DATA: ', url);
    return fetch(url, {
        headers: {
            // 'Content-Type': 'application/json',
            hgio: getToken(),
        },
        signal:signal?signal:null,
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Error fetching captures');
        })
        .then((data) => {
            logger.log(data);
            // var items = data.items.map((item,idx) => {
            //     const keys = Object.keys(item);
            //     var newItem = {};
            //     keys.forEach((key,idx) => {
            //         let tmpKey = key.replace(' ','');
            //         tmpKey = key.replace(':','_');
            //         // lowercase the first.
            //         let char = tmpKey.charAt(0).toLowerCase();
            //         let subStr = tmpKey.substring(1,tmpKey.length);
            //         const newKey = `${char}${subStr}`;
            //         newItem[newKey] = item[key]['S'];
            //         newItem.id = `${newItem.actionPart}__${newItem.actionSort}`;
            //     })
            //     return newItem
            // })
            // var items = data.items.map((item, idx) => {
            //     var newItem = new CaptureModel({ ...item });
            //     newItem.id = `${newItem.actionPart}__${newItem.actionSort}`;
            //     return newItem;
            // });
            var items = data.Items.map((item, idx) => {
                var newItem = new CaptureModel({ ...item });
                newItem.previewHi = item.hiURL;
                newItem.previewLo = item.loURL;
                newItem.id = `${newItem.actionPart}__${newItem.actionSort}`;

                return newItem;
            });

            return { items, nextCursor: data['next-cursor'] === 'nil' ? null : data['next-cursor'] };
        })
        .catch((err) => {
            if(doThrowOnResponse(err)){
                throw err
            }else{
                // return empty values back to the caller
                return {items:[], nextCursor:null}
            }
        });
};

export const getLatestCaptures = async (criteria) => {
    let url = `${process.env.REACT_APP_API_URL}/studioactions/s/latest`;

    logger.log(' GETTING Captures DATA: ', url);
    return fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Error fetching captures');
        })
        .then((data) => {
            logger.log(data);

            var items = data.items.map((item, idx) => {
                var newItem = new CaptureModel({ ...item });
                newItem.id = `${newItem.actionPart}__${newItem.actionSort}`;
                return newItem;
            });

            return items;
        })
        .catch((err) => {
            console.error('ERROR getting captures', err);
            throw err;
        });
};

///////////////////////
//
// STYLES
//
///////////////////////
export const getSessionStyles = async (criteria, token) => {
    var url = `${process.env.REACT_APP_API_URL}`;

  if (criteria && criteria.sessionId && criteria.sessionId.length) {
    url += `/session/${criteria.sessionId}/style`;
  }
  else {
    url += `/session`;
  }

  const formData = JSON.stringify({

  })

  logger.log(" GETTING SAMPLES DATA: ", formData);
  return fetch(url, {
    headers: {
      'hgio': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'GET',
    // body: formData,
  }).then((response) => {
    return response.json();
  }).then((data) => {
    logger.log(data)
    var items = data.Items.map((item, idx) => {
      const keys = Object.keys(item);
      
      var newItem = new SampleModel(parseValue(item));
      newItem.id = newItem.sampleId;
      newItem.desc = newItem.description ? newItem.description : newItem.descr;
      newItem.departmentStr = `${newItem.Dept} - ${newItem.department}`;

      const timeForecast = newItem.timeForecast ? JSON.parse(newItem.timeForecast) : [null, null];

      const momentDates = timeForecast.map(timestamp => 
        moment.unix(timestamp).toDate()
      );
           
      newItem.timeForecast = momentDates;
      if(newItem.departmentStr.trim() === '-'){
        newItem.departmentStr = '';
      }
      
      if (item.captures && item.captures["L"]) {
        newItem.captures = item.captures["L"].map(val => {
          return { id: val["S"] };
        })
      } else {
        newItem.captures = [];
      }

      return newItem
    })

    //items = items.splice(0,50)
    logger.log(items, ' getsamples')
    return items
    //return imgUploadUrl;
  })
    .catch((err) => {
      console.error('ERROR getting samples', err);
      throw (err);
    })
};

///////////////
// MARKUPS
///////////////
export const getMarkups = async (id, criteria) => {
    let url = `${process.env.REACT_APP_API_URL}/markup/${id}`;

    logger.log(' GETTING Captures DATA: ', url);
    return fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Error fetching markups');
        })
        .then((data) => {
            logger.log(data);
            const items = data.Items.map((val, idx) => {
                var item = createAnnotationModel(val);
                return item;
            });
            return items;
        })
        .catch((err) => {
            logger.error('ERROR getting markups', err);
            throw err;
        });
};

export const udpateMarkup = async (id, markup, token) => {
    let url = `${process.env.REACT_APP_API_URL}/markup/${id}`;

    if (markup.annSort) {
        url += `?annSort=${markup.annSort}`;
    }

    const formData = JSON.stringify({
        ...markup.payload,
        targetId: id,
    });

    logger.log(id, markup);
    logger.log(' UPDATING NOTE DATA: ', formData);

    return fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'PUT',
        body: formData,
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            logger.log(data);
            if (data.__type) {
                throw new Error('Sorry we were unable to save the note. Please try again later.');
            } else {
                var newItem;

                if (data) {
                    var item = data.Attributes;
                    const keys = Object.keys(data.Attributes);
                    newItem = new AnnotationModel();
                    keys.forEach((key, idx) => {
                        let tmpKey = key.replace(' ', '');
                        tmpKey = key.replace(':', '_');
                        // lowercase the first.
                        let char = tmpKey.charAt(0).toLowerCase();
                        let subStr = tmpKey.substring(1, tmpKey.length);
                        const newKey = `${char}${subStr}`;
                        newItem[newKey] = item[key]['S'];
                    });
                } else {
                }

                // newItem.id = `${newItem.sessionId}|${newItem.sessionSort}`;

                logger.log(newItem);
                //moment(newItem.deadline).format('DD-MM-YYYY');;

                return newItem;
            }
            //return imgUploadUrl;
        })
        .catch((err) => {
            console.error('ERROR updating markup', err);
            throw err;
        });
};

export const removeMarkup = async (id, markup, token) => {
    let url = `${process.env.REACT_APP_API_URL}/markup/${id}`;
    const formData = JSON.stringify({
        ...markup,
    });

    logger.log(' DELETING NOTE DATA: ', formData);
    return fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'POST',
        body: formData,
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Error removing markup');
        })
        .then((data) => {
            logger.log(data);
            //return imgUploadUrl;
        })
        .catch((err) => {
            console.error('ERROR updating markup', err);
            throw err;
        });
};

export const getAggData = async () => {
    let url = `${process.env.REACT_APP_API_URL}/agg`;

    return fetch(url, {
        headers: {
            // 'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            logger.log(data);

            const parsedObject = parseObjectTypes(data);
            const arrayKeys = ['machines'];

            const items = parsedObject.Items.map((val) => {
                var obj = { ...val };
                arrayKeys.forEach((newKey) => {
                    let tmpArr = obj[newKey].split(',');
                    let newVal = tmpArr.map((val) => {
                        let valArr = val.split(':');
                        return valArr.length > 2 ? { label: valArr[0], value: valArr[1] } : val;
                    });

                    obj[newKey] = newVal;
                });
                return obj;
            });

            //items = items.splice(0,50)
            logger.log(items, ' agg data');
            return items[0];
        })
        .catch((err) => {
            console.error('ERROR getting agg data', err);
            throw err;
        });
};

export const getDepartments = async () => {
    let url = `${process.env.REACT_APP_API_URL}/department`;
    return fetch(url, {
        headers: {
            // 'Content-Type': 'application/json',
            hgio: getToken(),
        },
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            logger.log(data);
            // sort by name alphabetically by 
            const departments = data.departments.map(department => {
                return {
                    code: department.code,
                    name: department.name,
                    fullName: `${department.code} - ${department.name}`,
                }
            })
            departments.sort((a, b) => a.fullName.localeCompare(b.fullName));
            return departments;
        })
        .catch((err) => {
            console.error('ERROR getting department data', err);
            throw err;
        });
};

///////////////////////
//
// TALENT
//
///////////////////////

export const getTalents = async (criteria, token) => {
    var url = `${process.env.REACT_APP_API_URL}/talent`;

    if (criteria) {
        if (criteria.styleCode) {
            url += `/style/${criteria.styleCode}`;
        }
        if (criteria.status) {
            url += `/${criteria.status}`;
        }
    }

    const formData = JSON.stringify({});

    logger.log(' GETTING SCANS DATA: ', formData);
    return fetch(url, {
        headers: {
            hgio: getToken(),
            'Content-Type': 'application/json',
        },
        method: 'GET',
        // body: formData,
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            logger.log(data);
            var items = data.Items.map((item, idx) => {
                return new TalentModel({...item,id:item.talentSort,fullName:`${item.first} ${item.last}`});
            });

            logger.log(items, ' get talent');
            return items;
        })
        .catch((err) => {
            console.error('ERROR getting scans', err);
            throw err;
        });
};

const createAnnotationModel = (item) => {
    const keys = Object.keys(item);
    var newItem = new AnnotationModel();
    keys.forEach((key, idx) => {
        let tmpKey = key.replace(' ', '');
        tmpKey = key.replace(':', '_');
        // lowercase the first.
        let char = tmpKey.charAt(0).toLowerCase();
        let subStr = tmpKey.substring(1, tmpKey.length);
        const newKey = `${char}${subStr}`;
        newItem[newKey] = item[key]['S'];
    });

    newItem.payload = JSON.parse(newItem.payload);
    logger.log(newItem);

    return newItem;
};
